import { render, staticRenderFns } from "./EmpresaNew.vue?vue&type=template&id=1570304e&scoped=true&"
import script from "./EmpresaNew.vue?vue&type=script&lang=ts&"
export * from "./EmpresaNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1570304e",
  null
  
)

export default component.exports